import { useState } from 'preact/hooks';
import { login } from '../state/session';
import { APP_VERSION } from '../version';

/** Passcode gate: numeric keypad, error next to the field, loading state on submit. */
export function Gate() {
  const [code, setCode] = useState('');
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);

  async function submit(e: Event) {
    e.preventDefault();
    if (!code.trim() || busy) return;
    setBusy(true);
    setErr('');
    const res = await login(code.trim());
    setBusy(false);
    if (!res.ok) {
      setErr(res.error || 'Wrong code');
      setCode('');
    }
  }

  return (
    <div class="flex min-h-dvh flex-col items-center justify-center bg-band px-6">
      <div class="w-full max-w-xs rounded-2xl bg-white p-6 shadow-2xl">
        <div class="mb-1 text-2xl font-extrabold text-navy-900">
          <span class="text-brand-600">Δ</span>T Service Schedule
        </div>
        <p class="mb-4 text-sm text-slate-500">Enter the crew access code.</p>
        <form onSubmit={submit}>
          <label class="mb-1 block text-sm font-semibold text-navy-900" for="accessCode">
            Access code
          </label>
          <input
            id="accessCode"
            class="tap w-full rounded-xl border border-slate-300 px-4 py-3 text-center text-2xl tracking-[0.3em] focus:border-brand-600"
            type="password"
            inputMode="numeric"
            autocomplete="one-time-code"
            value={code}
            onInput={(e) => setCode((e.target as HTMLInputElement).value)}
          />
          {err && (
            <p class="mt-2 text-sm font-semibold text-missed-ink" role="alert">
              {err}
            </p>
          )}
          <button class="btn-primary mt-4 w-full" type="submit" disabled={busy || !code.trim()}>
            {busy ? 'Checking…' : 'Unlock'}
          </button>
        </form>
      </div>
      <p class="mt-4 text-xs text-white/40" data-testid="app-version">
        v{APP_VERSION}
      </p>
    </div>
  );
}
